module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Gas-stove-948856e8c51b5f36ef597b88d29cccb6.svg";